import { isWebview } from '@src/helpers/webviews'

import InputField from '@components/forms/input_field'

import {
  MIN_PASSWORD_LENGTH,
  EMAIL_NOT_FOUND_ERROR,
  INCORRECT_PASSWORD_ERROR,
  GOOGLE_LANGUAGE_CODES,
  LAST_ATTEMPT_ERROR,
  LOCKED_ACCOUNT_ERROR,
  RECAPTCHA_ERROR
} from '../constants'

export function isFormValid(state) {
  return (
    !state.emailError &&
    !state.passwordError &&
    !state.recaptchaError &&
    !!state.recaptchaToken
  )
}

export function responseHasEmailNotFoundError(data) {
  return data.errors && EMAIL_NOT_FOUND_ERROR in data.errors
}

export function responseHasIncorrectPasswordError(data) {
  return data.errors && INCORRECT_PASSWORD_ERROR in data.errors
}

export function responseHasLastAttemptError(data) {
  return data.errors && LAST_ATTEMPT_ERROR in data.errors
}

export function responseHasLockedAccountError(data) {
  return data.errors && LOCKED_ACCOUNT_ERROR in data.errors
}

export function getEmailError(t, email) {
  if (InputField.EmailValidation(email)) {
    return t('e_email_invalid')
  } else if (InputField.EducationalEmailValidation(email)) {
    return t('e_email_use_personal')
  }
  return ''
}

export function getPasswordError(t, password) {
  if (!password) {
    return t('e_please_enter_password')
  } else if (password.length < MIN_PASSWORD_LENGTH) {
    return t('e_password_length')
  }
  return ''
}

export function canDisplayWrongPasswordScreen(data) {
  return data.providers && data.providers.length && !isWebview()
}

export function getCountry(country) {
  return country.toLowerCase()
}

export function getLanguageCode(country) {
  let language = 'en'
  GOOGLE_LANGUAGE_CODES.forEach((value, key) => {
    if (value.includes(getCountry(country))) {
      language = key
    }
  })
  return language
}

export const repsonseHasRecaptchaError = (data) => {
  return data.error && data.error === RECAPTCHA_ERROR
}
